<template>
    <b-card class="sa-card" header="Prestazioni" header-tag="header" footer-tag="footer" title="">
        <template #header>
            <span>Materiali</span>
            <div style="float: right" v-if="isEdit">
                <b-button variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddMateriale()" v-b-modal.mdlMateriali> <b-icon icon="plus"></b-icon>Aggiungi</b-button>
            </div>
        </template>
        <b-row>
            <div style="float: right"></div>
            <!-- <div class="b-table-sticky-header"> -->
            <b-table sticky-header ref="table" responsive stacked="xl" striped hover :items="prestazioni" :fields="fields" sort-icon-left head-variant="light" class="sa-b-table">
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(actions)="row">
                    <b-button size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(row.item)" v-if="isEdit">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
            <!-- </div> -->
        </b-row>
        <b-modal ref="mdlMateriali" id="mdlMateriali" size="md" style="height: 100%" @ok="onOkMdlMateriali" @cancel="onCancelMdlMateriali" title="Aggiungi Materiale ">
            <b-row>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="isMaterialiBotox">
                    <label class="sa-label-data">Categoria:</label>
                    <b-form-select v-model="categoriaMateriale" :options="categorieMaterialiOptions" value-field="value" text-field="text" @change="onChangeCategoriaMateriale"></b-form-select>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Materiale:</label>
                    <b-form-select v-model="prestazioneNuova.codiceMateriale" :options="listaPrestazioniOptions" :value="null" value-field="codice" text-field="descrizione" @change="onSetNomePrestazione"></b-form-select>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12" v-if="isMaterialiBotox">
                    <label class="sa-label-data">Lotto:</label>
                    <b-form-select v-model="prestazioneNuova.lotto" :options="getLottiMaterialeOptions()" value-field="id" text-field="descrizione" :disabled="!prestazioneNuova.codiceMateriale" @change="onChangeLottoMateriale"></b-form-select>
                </b-col>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Descrizione:</label>
                    <b-form-input class="form-control" v-model="prestazioneNuova.descrizioneMateriale" disabled></b-form-input>
                </b-col>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Prezzo Unitario:</label>
                    <b-form-input class="form-control" v-model="prestazioneNuova.prezzoUnuitario" disabled></b-form-input>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">
                        Quantita:<span v-if="getDisponibilitaLottoMateriale() !== null"> (disponibili: {{ getDisponibilitaLottoMateriale() }})</span>
                    </label>
                    <!-- <b-form-textarea v-model="prestazioneNuova.note" no-resize rows="6" style="margin-top: 3px"></b-form-textarea> -->
                    <b-form-input type="number" name="durata" class="form-control" v-model="prestazioneNuova.quantita" :state="isQuantitaMaterialeValida() ? null : false"></b-form-input>
                </b-col>
            </b-row>
        </b-modal>
    </b-card>
</template>

<script>
// import Vue from "vue";
import axios from "axios";
import moment from "moment";
export default {
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        contesto: {
            type: String,
            default: function () {
                return null;
            },
        },
        jsonData: {
            type: Object,
            default: function () {},
        },
        isEdit: Boolean,
        isMaterialiBotox: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
    },
    data() {
        return {
            pathResource: "/pazienteeventimaterialievento",
            pathResourceMateriali: "/pazienteeventimateriali",
            pathResourceProdottiBotox: "/externalbotox/prodotti",
            prestazioni: [],
            listaPrestazioniOptions: [{ codice: null, tipoPrestazione: "-Seleziona Valore-" }],
            listaMaterialiBotox: [],
            categoriaMateriale: null,
            categorieMaterialiOptions: [{ value: null, text: "-Tutte le categorie-" }],
            filtro: { gruppo: null, page: null, forPage: null },
            prestazioneNuova: { idEvento: null, codiceMateriale: null, descrizioneMateriale: null, categoriaMateriale: null, skuMateriale: null, lotto: null, lottoNumero: null, lottoScadenza: null },
            fields: [
                {
                    label: "",
                    key: "index",
                    thStyle: "width: 2rem",
                },
                {
                    label: "Cod. Materiale",
                    key: "CodiceMateriale",
                },
                {
                    label: "Materiale",
                    key: "descrizioneMateriale",
                    thStyle: "width: 10rem",
                },
                {
                    label: "Q.ta",
                    key: "quantita",
                    thStyle: "width: 10rem",
                },
                {
                    label: "P.zzo Unitario",
                    key: "prezzoUnuitario",
                    thStyle: "width: 10rem",
                },
                {
                    label: "",
                    key: "actions",
                    thStyle: "width: 8rem",
                },
            ],
        };
    },
    computed: {},
    watch: {
        idRisorsa() {
            let me = this;
            if (me.idRisorsa) {
                me.loadData();
            }
        },
    },
    methods: {
        // isViewNote(id) {
        //     let me = this;
        //     me.viewNote[id] = true;
        //     return me.viewNote[id];
        // },
        loadData() {
            let me = this;
            me.showModalLoading = true;
            if (me.id === "-1") {
                me.showModalLoading = false;
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource;
                axios.get(link, { params: { idEvento: me.idRisorsa } }).then((response) => {
                    me.prestazioni = response.data.data.list;
                    me.showModalLoading = false;
                });
            }
        },
        onAddMateriale() {
            let me = this;
            me.loadListaMateriali();
        },
        loadListaMateriali() {
            let me = this;
            // Eventi BOTOX: i materiali sono i prodotti dell'Hub Magazzino, come per la Fiala Aggiuntiva
            if (me.isMaterialiBotox) {
                me.loadListaMaterialiBotox();
                return;
            }
            //   console.log(me.jsonData);
            me.showModalLoading = true;
            me.listaPrestazioniOptions = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceMateriali;
            // me.filtro.gruppo = me.jsonData.gruppo;
            axios.get(link).then((response) => {
                me.listaPrestazioniOptions = response.data.data.list;
                me.listaPrestazioniOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
                me.showModalLoading = false;
            });
        },
        loadListaMaterialiBotox() {
            let me = this;
            me.showModalLoading = true;
            me.listaPrestazioniOptions = [];
            me.listaMaterialiBotox = [];
            me.categoriaMateriale = null;
            me.categorieMaterialiOptions = [{ value: null, text: "-Tutte le categorie-" }];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProdottiBotox;
            axios
                .get(link, { params: { idAmbulatorio: sessionStorage.getItem("idAmbulatorio") } })
                .then((response) => {
                    me.listaMaterialiBotox = response.data.data.map((prodotto) => ({
                        codice: String(prodotto.id),
                        descrizione: prodotto.name,
                        prezzo: prodotto.current_cost,
                        categoria: prodotto.category_name,
                        sku: prodotto.sku,
                        batches: prodotto.batches ? prodotto.batches : [],
                    }));
                    // Categorie distinte ricavate dai prodotti
                    let categorie = [];
                    me.listaMaterialiBotox.forEach((materiale) => {
                        if (materiale.categoria && !categorie.includes(materiale.categoria)) {
                            categorie.push(materiale.categoria);
                        }
                    });
                    categorie.sort((a, b) => a.localeCompare(b));
                    categorie.forEach((categoria) => {
                        me.categorieMaterialiOptions.push({ value: categoria, text: categoria });
                    });
                    me.setListaMaterialiBotoxFiltrata();
                    me.showModalLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    me.listaPrestazioniOptions = [{ codice: null, descrizione: "-Seleziona Valore-" }];
                    me.showModalLoading = false;
                });
        },
        setListaMaterialiBotoxFiltrata() {
            let me = this;
            me.listaPrestazioniOptions = me.listaMaterialiBotox.filter((materiale) => !me.categoriaMateriale || materiale.categoria === me.categoriaMateriale);
            me.listaPrestazioniOptions.unshift({ codice: null, descrizione: "-Seleziona Valore-" });
        },
        onChangeCategoriaMateriale() {
            let me = this;
            // Cambiando categoria il materiale selezionato non è più valido
            me.prestazioneNuova.codiceMateriale = null;
            me.prestazioneNuova.descrizioneMateriale = null;
            me.prestazioneNuova.prezzoUnuitario = null;
            me.prestazioneNuova.categoriaMateriale = null;
            me.prestazioneNuova.skuMateriale = null;
            me.prestazioneNuova.lotto = null;
            me.prestazioneNuova.lottoNumero = null;
            me.prestazioneNuova.lottoScadenza = null;
            me.setListaMaterialiBotoxFiltrata();
        },
        onDelete(jsonData) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sei sicuro di procedere alla cancellazione?", {
                    title: "Conferma Cancellazione",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deletePrestazione(jsonData);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deletePrestazione(jsonData) {
            let me = this;
            //   console.log(jsonData);
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + jsonData.id;
            axios
                .delete(link)
                .then(() => {
                    me.loadData();
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onOkMdlMateriali() {
            let me = this;
            me.prestazioneNuova.idEvento = me.idRisorsa;
            me.salvaPrestazioni();
            me.prestazioneNuova = { idEvento: null, codiceMateriale: null, descrizioneMateriale: null, categoriaMateriale: null, skuMateriale: null, lotto: null, lottoNumero: null, lottoScadenza: null };
            me.categoriaMateriale = null;
            //   me.prestazioni.push(me.prestazioneNuova);
        },
        onCancelMdlMateriali() {
            let me = this;
            me.prestazioneNuova = { idEvento: null, codiceMateriale: null, descrizioneMateriale: null, categoriaMateriale: null, skuMateriale: null, lotto: null, lottoNumero: null, lottoScadenza: null };
            me.categoriaMateriale = null;
        },
        salvaPrestazioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            axios
                .post(link, me.prestazioneNuova)
                .then((response) => {
                    // console.log(response);
                    this.$saToast.success(response.data.messaggio);
                    me.loadData();
                })
                .catch((e) => {
                    console.log(e.messaggio);
                    this.$bvModal
                        .msgBoxOk(e.response.data.messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {})
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        onSetNomePrestazione() {
            let me = this;
            me.listaPrestazioniOptions.forEach((element) => {
                if (element.codice === me.prestazioneNuova.codiceMateriale) {
                    me.prestazioneNuova.descrizioneMateriale = element.descrizione;
                    me.prestazioneNuova.prezzoUnuitario = element.prezzo;
                    if (me.isMaterialiBotox) {
                        me.prestazioneNuova.categoriaMateriale = element.categoria;
                        me.prestazioneNuova.skuMateriale = element.sku;
                    }
                }
            });
            // Cambiando materiale il lotto selezionato non è più valido
            me.prestazioneNuova.lotto = null;
            me.prestazioneNuova.lottoNumero = null;
            me.prestazioneNuova.lottoScadenza = null;
            // console.log(me.prestazioneNuova);
        },
        getLottiMaterialeDisponibili() {
            let me = this;
            const materiale = me.listaMaterialiBotox.find((element) => element.codice === me.prestazioneNuova.codiceMateriale);

            if (!materiale || !materiale.batches) {
                return [];
            }
            let oggi = moment().format("YYYY-MM-DD");
            // Solo lotti con giacenza e non scaduti, il più vicino alla scadenza per primo
            return materiale.batches.filter((lotto) => lotto.stock_quantity > 0 && (!lotto.expiry_date || lotto.expiry_date >= oggi)).sort((a, b) => (a.expiry_date || "").localeCompare(b.expiry_date || ""));
        },
        getLottiMaterialeOptions() {
            let me = this;
            let opzioni = me.getLottiMaterialeDisponibili().map((lotto) => ({
                id: lotto.id,
                descrizione: lotto.batch_number + (lotto.expiry_date ? " - scad. " + moment(lotto.expiry_date).format("DD-MM-YYYY") : "") + " (disp. " + lotto.stock_quantity + ")",
            }));
            opzioni.unshift({ id: null, descrizione: "-Seleziona Valore-" });
            return opzioni;
        },
        onChangeLottoMateriale(idLotto) {
            let me = this;
            const lotto = me.getLottiMaterialeDisponibili().find((element) => element.id === idLotto);
            if (lotto) {
                me.prestazioneNuova.lottoNumero = lotto.batch_number;
                me.prestazioneNuova.lottoScadenza = lotto.expiry_date;
            } else {
                me.prestazioneNuova.lottoNumero = null;
                me.prestazioneNuova.lottoScadenza = null;
            }
        },
        getDisponibilitaLottoMateriale() {
            let me = this;
            if (!me.isMaterialiBotox || !me.prestazioneNuova.lotto) {
                return null;
            }
            const lotto = me.getLottiMaterialeDisponibili().find((element) => element.id === me.prestazioneNuova.lotto);
            return lotto ? lotto.stock_quantity : null;
        },
        isQuantitaMaterialeValida() {
            let me = this;
            let disponibilita = me.getDisponibilitaLottoMateriale();
            if (disponibilita === null) {
                return true;
            }
            return Number(me.prestazioneNuova.quantita) <= disponibilita;
        },
    },
};
</script>

<style>
.hide-file-input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.file-label {
    color: #fff;
    background-color: #3730a3;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    cursor: pointer;
}
input[type="file"]:focus + .file-label {
    box-shadow: 0 0 0 4px #bae6fd;
}

.sa-drop-image {
    background-color: #f0f0f0;
    width: 100%;
    aspect-ratio: 1/ 1;
    border: 1px #666 dashed;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.sa-image-upload-icon {
    display: flex;
    align-items: center;
    font-size: 5rem;
    margin: auto;
}
.sa-drop-image span {
    margin-top: 10px;
}

.sa-pei-btn-icon {
    padding-left: 5px;
    padding-top: 1px;
    font-size: 1.25rem;
}
.sa-pei-chk {
    width: 150px;
    padding-bottom: 0px !important;
}
.sa-pei-chk-label {
    font-size: 0.75rem;
    font-weight: 500;
    padding-left: 3px;
}
.sa-pei-input {
    width: 100%;
    font-size: 0.75rem;
    padding: 0px;
    height: 25px;
    margin-right: 3px;
    border: 1px solid rgb(201, 201, 201);
}
.sa-pei-chk .custom-control-label {
    padding-top: 3px;
}
/* .sa-pei-chk .custom-control-input {
    margin-left: 3px;
} */
</style>
